<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const props = defineProps({
  color: {
    default: "#000",
  },
  disabled: {
    default: false,
  },
});

const iconSize = ref("15rem");

onMounted(() => {
  updateIconSize();
  window.addEventListener("resize", updateIconSize);
});

const updateIconSize = () => {
  if (window.innerWidth <= 576) {
    iconSize.value = "2.5rem";
  } else {
    iconSize.value = "2.5rem";
  }
};

onUnmounted(() => {
  window.removeEventListener("resize", updateIconSize);
});
</script>

<template>
  <db-icon
    id="electric-locomotive"
    icon="electric-locomotive"
    variant=""
    :style="{
      '--icon-font-size': iconSize,
      '--icon-font-family': 'icons-20-filled',
      '--icon-font-weight': 400,
      color: `${disabled ? 'grey' : color}`,
    }"
    class="hydrated active:shadow w-15 h-15 cursor-pointer"
  ></db-icon>
</template>
